module.exports = __webpack_public_path__ + "static/aredux-1803c936ebf7b98b4fb5a6e0ad726152.gif";